<router-outlet />
<!-- トースト通知（全画面共通。ログイン画面もカバーするためルートに配置） -->
<app-toast-container />
